import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export const QuickLinkItem = ({
  name,
  label,
  image,
  imageSrc,
  link,
  openInNewTab,
  showNewRibbon
}: {
  name: string,
  label?: string,
  image?: React.ReactNode,
  imageSrc?: string,
  link: string,
  openInNewTab?: boolean,
  showNewRibbon?: boolean
}) => {
  const { t } = useTranslation()
  const href = openInNewTab
    ? (link.startsWith('http')
        ? link
        : link.startsWith('/')
          ? `${window.location.origin}${link}`
          : `https://${link}`)
    : undefined
  const title = label ?? t(name) ?? ''

  const content = (
    <>
      <div className='image-holder'>
        {imageSrc ? <img src={imageSrc} alt={title} width={118} height={118} /> : image}
      </div>
      <h3 role='heading'>{title}</h3>
      {showNewRibbon && <span className='campaign-new-ribbon'>NEW</span>}
    </>
  )

  const className = `services-board-item-holder${showNewRibbon ? ' campaign-item-holder' : ''}`

  if (openInNewTab && href) {
    return (
      <a className={className} href={href} target='_blank' rel='noopener noreferrer' role='link'>
        {content}
      </a>
    )
  }

  return (
    <Link className={className} to={link} role='link'>
      {content}
    </Link>
  )
}
